import { render } from "./ClientSecretsComponent.vue?vue&type=template&id=1327c7d6"
import script from "./ClientSecretsComponent.vue?vue&type=script&lang=js"
export * from "./ClientSecretsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__